import { render, staticRenderFns } from "./ativosFixosEditar.vue?vue&type=template&id=0653ce9b&scoped=true&"
import script from "./ativosFixosEditar.vue?vue&type=script&lang=js&"
export * from "./ativosFixosEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0653ce9b",
  null
  
)

export default component.exports